<template>
  <v-layout class="small-text" row wrap>
    <v-flex column justify-end>
      <v-flex class="taxi-list-total-count">
        <b class="taxi-list-header">Drivers:</b>
        {{ taxis.length }}
      </v-flex>
      <v-flex class="taxi-list-total-count">
        <b class="taxi-list-header">Trips:</b>
        {{ bookings.length }}
      </v-flex>
    </v-flex>
    <v-flex v-for="rideType in enabledRideTypes">
      <v-layout column>
        <span>
          <b class="taxi-list-header">{{rideType.name}}:</b>
          {{taxisForRideTypes(rideType.id).length}}
          <b
            v-if="rideTypeEtas != null"
            v-bind:style="colorForRideTypeEta(rideType)"
          >{{ rideTypeEtas["ride_type_" + rideType.id] > 9999 ? "n/a" : rideTypeEtas["ride_type_" + rideType.id] + "m" }}</b>
        </span>
        <p>
          <b class="taxi-list-header">{{rideType.name}}:</b>
          {{bookingsForRideTypes(rideType.id).length}}
        </p>
        <ul class="taxi-driver-list">
          <li
            v-for="item in taxisForRideTypes(rideType.id)"
            @click="setSelectedTaxi(item.id)"
            style="cursor: pointer"
          >
            <v-menu
              right
              offset-x
              :close-on-content-click="false"
              v-model="menu[item.id.toString()]"
            >
              <template v-slot:activator="{ on }">
                <div @click="showMenuForTaxi(item.id)" style="padding-top: 2.0px;">
                  <span
                    v-bind:style="selectedTaxiStyle(item)"
                    v-on="on"
                    v-html="stateForTaxi(item)"
                  ></span>
                </div>
              </template>
              <DriverMenu
                @message="message"
                :taxi="item"
                @close="menu[item.id.toString()] = false"
              />
            </v-menu>
          </li>
        </ul>
      </v-layout>
    </v-flex>
    <v-dialog v-model="messageDialog" width="600px">
      <MessageDriverDialog @sent="messageDialog = false" :taxi="taxi" />
    </v-dialog>
  </v-layout>
</template>

<script>
import DriverMenu from "@/components/widget/menu/DriverMenu.vue";

import { Overwatch } from "@/components/util/Overwatch.js";
import MessageDriverDialog from "@/components/widget/menu/MessageDriverDialog.vue";

export default {
  name: "taxi_list",
  components: {
    DriverMenu,
    MessageDriverDialog
  },
  model: {
    prop: "content",
    event: "input"
  },
  props: {
    taxis: Array,
    bookings: Array,
    rideTypes: Array,
    rideTypeEtas: Object,
    setSelectedTaxi: Function,
    selectedTaxi: Number
  },
  computed: {
    enabledRideTypes: function() {
      if (this.rideTypes == null) {
        return [];
      }
      return this.rideTypes.filter(function(rt) {
        return rt.enabled == true;
      });
    }
  },
  data() {
    return {
      ABOUT_TO_CLEAR_TIME: 1,
      menu: [],
      messageDialog: false,
      taxi: null
    };
  },
  methods: {
    message: function(taxi) {
      console.log("Message dialog");
      this.messageDialog = true;
      this.taxi = taxi;
    },
    showMenuForTaxi: function(id) {
      console.log("Show menu for taxi " + id);
      this.menu[id.toString()] = true;
    },
    colorForRideTypeEta: function(rideType) {
      return {
        color:
          this.rideTypeEtas["ride_type_" + rideType.id] >
          rideType.availability_warning_threshold
            ? "lightcoral"
            : "limegreen"
      };
    },
    selectedTaxiStyle: function(taxi) {
      var style = {
        padding: "2px",
        borderRadius: "6px"
      };

      if (taxi.id == this.selectedTaxi) {
        style.color = "white";
        style.backgroundColor = "black";
      } else {
        var ow = new Overwatch(this.taxis, this.bookings);

        style.color = "black";
        style.backgroundColor = ow.colorForTaxi(taxi);
      }

      return style;
    },
    stateForTaxi: function(taxi) {
      var ow = new Overwatch(this.taxis, this.bookings);

      return ow.stateForTaxi(taxi);
    },
    taxisForRideTypes: function(id, count) {
      if (this.taxis == null) {
        return [];
      }

      var ow = new Overwatch(this.taxis, this.bookings);

      return ow.sortTaxisByState(
        this.taxis.filter(function(t) {
          return t.ride_type_id == id;
        })
      );
    },
    bookingsForRideTypes: function(id) {
      if (this.bookings == null) {
        return [];
      }

      return this.bookings.filter(function(b) {
        return b.ride_type == id;
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
ul {
  list-style: none;
  padding-left: 0px;
}

.taxi-list-header {
  color: #10425a;
}

.small-text {
  font-size: 13px;
}
</style>
